import React, { Component } from 'react';
import { FAIcon } from '../../../icons';

export default class RatingCheckbox extends Component {
  render() {
    const { checked } = this.props;
    const icon = checked ? FAIcon('star', { style: { fontSize: '20px', color: 'rgba(76, 175, 80, 0.8)' }}) : FAIcon('star-empty', { stlye: { fontSize: '20px', color: 'rgba(76, 175, 80, 0.8)' }});

    return (
      <span>
        {icon}
      </span>
    );
  }
}
